// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k5-option .kt-option__head span[data-v-7c91a35e]{font-size:1.5rem!important}.k5-option .kt-option__head span .kt-option__focus[data-v-7c91a35e]{font-weight:700!important}.discounted-text[data-v-7c91a35e]{font-size:1.3rem!important;font-style:italic}", ""]);
// Exports
module.exports = exports;
